import { render } from "./TicketBuyerTypes.vue?vue&type=template&id=6359f636&scoped=true"
import script from "./TicketBuyerTypes.vue?vue&type=script&lang=js"
export * from "./TicketBuyerTypes.vue?vue&type=script&lang=js"

import "./TicketBuyerTypes.vue?vue&type=style&index=0&id=6359f636&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6359f636"]])

export default __exports__